import React from 'react'
import { Link } from 'gatsby'
import styles from './classes.module.scss'

import PageHeader from '../components/page-header'

export default ({ classes }) => (
  <div className={`${styles.classes}`}>
    <div className="wrapper">
      <PageHeader
        classes={true}
        pageTitle={'The Classes'}
        lede="Our classes cover tumbling, sports acrobatics, women’s artistic, general, rhythmic, trampolining."
        text={
          'We offer gymnastics and trampolining for all ages and abilities, from pre-school up to adults.'
        }
      />
      <div className={`${styles.classesBlockWrap}`}>
        {classes.map(({ node }) => {
          return (
            <span key={node.slug}>
              {node.tags == 'current-classes' ? (
                <div className={`${styles.classesBlockCta} divider-up `}>
                  <Link
                    className={styles.classesBlockLink}
                    to={`/blog/${node.slug}`}
                  >
                    <h3 className={`${styles.classesBlockTitle} heading h2`}>
                      {node.title}
                    </h3>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: node.description.childMarkdownRemark.html,
                      }}
                    />
                  </Link>
                </div>
              ) : (
                ''
              )}
            </span>
          )
        })}
      </div>
    </div>
  </div>
)
